import { useTranslation } from 'next-i18next'
import { FC } from 'react'
import { IJobBase } from '@/types'
import { getFormattedAmount } from '@/utils'
import { IconTextItem } from '@components-v2/atoms/IconTextItem'
import CurrencySVg from '@/public/images/common/currency-dollar-circle_v2.svg'
import ClockSVg from '@/public/images/common/clock_v2.svg'
import MarkerPinSvg from '@/public/images/common/marker-pin-01_v2.svg'
import styles from './index.module.scss'

type Props = {
  job: IJobBase
}

export const JobAttributes: FC<Props> = ({ job }) => {
  const { t } = useTranslation('jobs')

  const formattedMInSalary = getFormattedAmount(Number(job?.minMonthlySalary), job?.currencyUnit)
  const formattedMaxSalary = getFormattedAmount(Number(job?.maxMonthlySalary), job?.currencyUnit)
  return (
    <div className={styles.container}>
      {/* locations */}
      {job?.locations?.length > 0 && (
        <IconTextItem
          icon={<MarkerPinSvg viewBox='0 0 24 24' />}
          nameList={job?.locations.map((s) => s.name)}
          suffix={t(job.workingForm)}
        />
      )}

      {/* typeOfPosition */}
      <IconTextItem icon={<ClockSVg viewBox='0 0 20 20' />} nameList={[`${t(job.typeOfPosition)}`]} />

      {/* salary */}
      <IconTextItem
        icon={<CurrencySVg viewBox='0 0 24 24' />}
        nameList={[`${formattedMInSalary} - ${formattedMaxSalary}`]}
      />

      {/* TODO: 以下一旦非表示 */}
      {/* skills */}
      {/* {job?.skills?.length > 0 && (
        <IconTextItem
          // TODO icon
          icon={<CurrencySVg viewBox='0 0 24 24' />}
          nameList={job?.skills.map((s) => s.name)}
        />
      )} */}
      {/* jobTags */}
      {/* <IconTextItem
        // TODO icon
        icon={<CurrencySVg viewBox='0 0 24 24' />}
        nameList={job?.jobTags.map((s) => s.name)}
      /> */}
    </div>
  )
}
